export default [
    {
        path: '/good-news-share',
        name: 'goodNews',
        meta: {
            title: '沾沾成单喜气 瓜分现金红包',
            activity: true
        },
        component: () => import('@/views/share-page/goodNews.vue')
    }, {
        path: '/article-share',
        name: 'article',
        meta: {
            title: '文章详情',
            activity: true
        },
        component: () => import('@/views/share-page/article.vue')
    }, {
        path: '/collaboration-share',
        name: 'collaboration',
        meta: {
            title: '协作详情',
            activity: true
        },
        component: () => import('@/views/share-page/collaboration.vue')
    },
]
